import { NewCardSection } from './NewCardSection';
import { ExistingCardDetails } from './ExistingCardDetails';
import { PayRentTypes } from '../../PayRentTypes';
import { BillingDetails } from './BillingDetails';
import React, { useState } from 'react';
import {
  amountResolutionType,
  existingCardsSectionLabels,
} from '../../constants/accountPanelConfigs';
import { Column, Columns } from '@codeparva/ui-components-library';
import { getAmountToPay } from '../../../rentalPage/helpers/paymentComponentHelper';

export const ExistingCardSection = ({
  cardType,
  card_info,
  facilityId,
  customAmount,
  payment_method,
  callBackHandler,
  setCustomAmount,
  card_holder_info,
  customAmountError,
  setChargesDetails,
  cardProcessorIds,
  amountResolution,
  is_auto_pay_enabled,
  setAmountResolution,
  billingDetailsConfig,
  preferred_payment_method_id,
  isSurchargeOrDiscountAvailable,
  chargesDetails = {},
  tfwPaymentConfig: {
    is_autopay_opt_in_enabled: isAutoPayOptInEnabled,
    is_autopay_opt_out_enabled: isAutoPayOptOutEnabled,
    is_partial_payment_enabled: isPartialPaymentAllowed = false,
    is_pre_payment_enabled: isPrepaymentAllowed = false,
    is_ach_payment_enabled: isAchPaymentEnabled = false,
  } = {},
  paymentType,
  setPaymentType,
  public_key,
  tenantToken,
}: PayRentTypes.TExistingCardSection) => {
  const { useExistingLabel, useNewLabel } = existingCardsSectionLabels;
  const [useExisting, setUseExisting] = useState(true);
  const checkboxHandler = (checkboxType: string) => {
    if (checkboxType === 'useExisting') {
      setUseExisting(true);
    } else {
      setUseExisting(false);
    }
  };
  const { current_balance_due = 0, new_balance = 0 } =
    billingDetailsConfig ?? {};

  const hidePayments =
    parseFloat(current_balance_due.toString()) <= 0 && !isPartialPaymentAllowed;
  const isPaymentDisabled = () => {
    if (customAmountError?.current) return true;
    if (amountResolution === amountResolutionType.balanceAmount) {
      return Number(current_balance_due) <= 0;
    }
    // For custom amount
    return (
      Number(
        getAmountToPay(
          { current_balance_due, new_balance: customAmount || new_balance },
          true
        )
      ) <= 0
    );
  };

  return (
    <Columns className="existingCardInfoParentSection is-desktop py-0">
      <Column className="billingDetailsSection">
        <BillingDetails
          {...billingDetailsConfig}
          facility_id={facilityId}
          customAmount={customAmount}
          setCustomAmount={setCustomAmount}
          amountResolution={amountResolution}
          customAmountError={customAmountError}
          setAmountResolution={setAmountResolution}
          isPrepaymentAllowed={isPrepaymentAllowed}
          parentChargeDetailsUpdater={setChargesDetails}
          isPartialPaymentAllowed={isPartialPaymentAllowed}
          preferred_payment_method_id={preferred_payment_method_id}
          isCardPaymentTypeChanges={useExisting && customAmount ? true : false}
          tenantToken={tenantToken}
        />
      </Column>
      {!hidePayments && (
        <Column className="savedCardInfoParentSection">
          <div className="savedCardInformationSection">
            <h5>Card Information</h5>
            <div className="cardOnFileInformationSection">
              <div className="cardInfoSection">
                <div
                  className="existingCardCheckbox"
                  onClick={() => checkboxHandler('useExisting')}
                  data-testid="use-existing-checkbox"
                >
                  <input type="radio" checked={useExisting ? true : false} />
                  <span className="radio-label">{useExistingLabel}</span>
                </div>
                <div>
                  {useExisting === true ? (
                    <ExistingCardDetails
                      cardType={cardType}
                      card_info={card_info}
                      hidePayments={hidePayments}
                      customAmount={customAmount}
                      callBackHandler={callBackHandler}
                      cardProcessorIds={cardProcessorIds}
                      card_holder_info={card_holder_info}
                      disablePayment={isPaymentDisabled()}
                      is_auto_pay_enabled={is_auto_pay_enabled}
                      billingDetailsConfig={billingDetailsConfig}
                      isAutoPayOptInEnabled={isAutoPayOptInEnabled}
                      isAutoPayOptOutEnabled={isAutoPayOptOutEnabled}
                      preferred_payment_method_id={preferred_payment_method_id}
                      chargeDetails={chargesDetails}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="newCardPaymentSection">
                <div
                  className="existingCardCheckbox"
                  onClick={() => checkboxHandler('useNew')}
                  data-testid="use-existing-checkbox"
                >
                  <input type="radio" checked={!useExisting ? true : false} />
                  <span className="radio-label">{useNewLabel}</span>
                </div>
                <div>
                  {useExisting === false ? (
                    <NewCardSection
                      facilityId={facilityId}
                      customAmount={customAmount}
                      payment_method={payment_method}
                      callBackHandler={callBackHandler}
                      setCustomAmount={setCustomAmount}
                      amountResolution={amountResolution}
                      cardProcessorIds={cardProcessorIds}
                      customAmountError={customAmountError}
                      setAmountResolution={setAmountResolution}
                      billingDetailsConfig={billingDetailsConfig}
                      parentChargeDetailsUpdater={setChargesDetails}
                      isSurchargeOrDiscountAvailable={
                        isSurchargeOrDiscountAvailable
                      }
                      tfwPaymentConfig={{
                        is_autopay_opt_in_enabled: isAutoPayOptInEnabled,
                        is_autopay_opt_out_enabled: isAutoPayOptOutEnabled,
                        is_partial_payment_enabled: isPartialPaymentAllowed,
                        is_pre_payment_enabled: isPrepaymentAllowed,
                        is_ach_payment_enabled: isAchPaymentEnabled,
                      }}
                      paymentType={paymentType}
                      setPaymentType={setPaymentType}
                      public_key={public_key}
                      tenantToken={tenantToken}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </Column>
      )}
    </Columns>
  );
};
